export const REQUEST_FILE_EXTENSIONS = "REQUEST_FILE_EXTENSIONS";
export const RECEIVE_FILE_EXTENSIONS = "RECEIVE_FILE_EXTENSIONS";